import { render, staticRenderFns } from "./Parcelclaim.vue?vue&type=template&id=78ee627e&scoped=true&"
import script from "./Parcelclaim_.js?vue&type=script&lang=js&"
export * from "./Parcelclaim_.js?vue&type=script&lang=js&"
import style0 from "./Parcelclaim.vue?vue&type=style&index=0&id=78ee627e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ee627e",
  null
  
)

export default component.exports